import React, { useEffect, useState } from "react";
import "./css/Main.css";
import SidebarMenu from "./components/SidebarMenu";
import Footer from "./components/Footer";
import Main from "./routes/Main";
import Navbar from "./components/Navbar";
import { useMenu } from "./context/MenuContext";
import useMobile from "./hooks/useMobile";
import useTab from "./hooks/useTab";
import ToTop from "./components/ToTop";
import { Element } from "react-scroll";
import Loader from "./components/Loader";
import { useLoader } from "./context/LoaderContext";
import { fetchCompanyDetails } from "./api/CompanyDetailsApi";
import { dynamicFailed } from "./hooks/useToast";
import { useCompanyDetailsContext } from "./context/CompanyDetailsContext";
import WhatsApp from "./components/WhatsApp";

const MainPage = () => {
  const [showNavbar, setShowNavbar] = useState(true);
  const isMobile = useMobile();
  const isTab = useTab();
  const { menuOpen } = useMenu();
  // const [showContent, setShowContent] = useState(false);
  const { loading } = useLoader();
  const { companyDetailsData, setCompanyDetailsData } =
    useCompanyDetailsContext();

  useEffect(() => {
    const preventScroll = (e: any) => {
      e.preventDefault();
    };

    if (loading) {
      window.addEventListener("wheel", preventScroll, { passive: false });
      window.addEventListener("touchmove", preventScroll, { passive: false });
    } else {
      window.removeEventListener("wheel", preventScroll);
      window.removeEventListener("touchmove", preventScroll);
    }

    return () => {
      window.removeEventListener("wheel", preventScroll);
      window.removeEventListener("touchmove", preventScroll);
    };
  }, [loading]);

  useEffect(() => {
    // setTimeout(() => {
    //   setLoading(false);
    // }, 3000);

    const handleScroll = () => {
      if (window.scrollY > 100) {
        setShowNavbar(false);
      } else {
        setShowNavbar(true);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (companyDetailsData.length === 0) {
      Promise.all([fetchCompanyDetails()])
        .then(([CompanyDetailsData]) => {
          setCompanyDetailsData(CompanyDetailsData);
        })
        .catch((error) => {
          dynamicFailed(error.response.data.error.message);
        });
    }
  }, [companyDetailsData.length, setCompanyDetailsData]);

  return (
    <>
      {/* {menuOpen ? (
        <div id="outer-container">
          <SidebarMenu />
          <main id="page-wrap"> */}
      {/* Begin content */}
      {/* <Navbar />
            <div
              id="page_content_wrapper"
              className="noheader"
              style={{ padding: "unset" }}
            >
              <div className="inner"> */}
      {/* Main content */}
      {/* <div className="inner_wrapper">
                  <div className="sidebar_content full_width">
                    <div
                      data-elementor-type="wp-post"
                      data-elementor-id="662"
                      className="elementor elementor-662"
                      data-elementor-settings="[]"
                    >
                      <div className="elementor-inner">
                        <div className="elementor-section-wrap">
                          <Carousel />
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
      {/* End main content */}
      {/* </div>
              <br className="clear" />
            </div>
          </main>
        </div>
      ) : (
          <>
            {showNavbar && <Navbar />}
            <Main />
            <Footer />
          </>
        
      )} */}
      {/* {!loading && ( */}
      <div id="outer-container">
        <Element name="toTop"></Element>
        <SidebarMenu />
        <div
          id="page-wrap"
          style={{
            height: "100dvh",
            marginLeft: menuOpen && !isMobile && !isTab ? "100px" : "0px",
          }}
        >
          <div>
            {showNavbar && <Navbar />}
            <Main />
            <Footer />
            {!showNavbar && <ToTop />}
            <WhatsApp />
          </div>
        </div>
      </div>
      {/* )} */}
      <Loader />
    </>
  );
};

export default MainPage;
